import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/foam-roofing.html")({
  beforeLoad: () => { throw redirect({ to: "/foam-roofing", statusCode: 301 }); },
});
